module.exports = __webpack_public_path__ + "002b2fa8bd1a24e429c9f2e882afd260.png";